import { FileViewer, type IFileViewerProps } from './FileViewer'
import { Modal } from '../Modal'
import { FileViewerModalStyled } from './styles/FileViewerModalStyled'
import { TransparentIconButton } from '@ui/elements/Button'
import { IconX } from '@ui/elements/Icon'

export interface IFileViewerModalProps extends IFileViewerProps {
  open?: boolean
  onDismiss?: () => void
}

export const FileViewerModal = ({
  open = false,
  onDismiss = () => undefined,
  ...FileViewerProps
}: IFileViewerModalProps) => {
  return (
    <Modal
      maxWidth='sm'
      open={open}
      onClose={onDismiss}
      disableEnforceFocus
      fullScreen
    >
      <FileViewerModalStyled>
        <FileViewer {...FileViewerProps} />
        <TransparentIconButton
          iconComponent={<IconX />}
          onClick={onDismiss}
          iconColor='textInverse'
          aria-label='Close file viewer'
          className='close-button'
        />
      </FileViewerModalStyled>
    </Modal>
  )
}

FileViewerModal.displayName = 'FileViewerModal'
